/**
 * consentEngine.js — Re Leve IA (Etapa 5)
 * Gerencia consentimento para acompanhamento calórico informativo.
 * G06: exige consentimento antes de qualquer registro calórico.
 */

import {
  getStoredConsent,
  setStoredConsent,
  addSessionEvent,
} from './localStorageEngine';

// Estados possíveis de consentimento
export const CONSENT_STATUS = {
  NOT_REQUESTED: 'not_requested',
  REQUESTED: 'requested',
  GRANTED: 'granted',
  DENIED: 'denied',
};

export function getConsentStatus(clienteId) {
  if (!clienteId) return CONSENT_STATUS.NOT_REQUESTED;
  const stored = getStoredConsent(clienteId);
  if (!stored) return CONSENT_STATUS.NOT_REQUESTED;
  return stored.status || CONSENT_STATUS.NOT_REQUESTED;
}

export function hasCalorieConsent(clienteId) {
  return getConsentStatus(clienteId) === CONSENT_STATUS.GRANTED;
}

export function requestCalorieConsent(clienteId) {
  if (!clienteId) return null;
  const current = getConsentStatus(clienteId);
  if (current === CONSENT_STATUS.GRANTED) return getStoredConsent(clienteId);

  const record = setStoredConsent(clienteId, {
    granted: false,
    status: CONSENT_STATUS.REQUESTED,
    scope: 'acompanhamento_calorico_informativo',
    message: 'Solicitação de consentimento enviada ao cliente',
  });
  addSessionEvent(clienteId, {
    eventType: 'consent_requested',
    description: 'Bot solicitou consentimento para acompanhamento calórico',
  });
  return record;
}

export function grantCalorieConsent(clienteId) {
  if (!clienteId) return null;
  const record = setStoredConsent(clienteId, {
    granted: true,
    status: CONSENT_STATUS.GRANTED,
    scope: 'acompanhamento_calorico_informativo',
    message: 'Cliente autorizou acompanhamento calórico informativo',
  });
  addSessionEvent(clienteId, {
    eventType: 'consent_granted',
    description: 'Cliente autorizou acompanhamento calórico informativo',
  });
  return record;
}

export function denyCalorieConsent(clienteId) {
  if (!clienteId) return null;
  const record = setStoredConsent(clienteId, {
    granted: false,
    status: CONSENT_STATUS.DENIED,
    scope: 'acompanhamento_calorico_informativo',
    message: 'Cliente negou acompanhamento calórico',
  });
  addSessionEvent(clienteId, {
    eventType: 'consent_denied',
    description: 'Cliente não autorizou acompanhamento calórico',
  });
  return record;
}

export function getConsentStatusLabel(clienteId) {
  const status = getConsentStatus(clienteId);
  switch (status) {
    case CONSENT_STATUS.GRANTED: return 'Autorizado';
    case CONSENT_STATUS.DENIED: return 'Negado';
    case CONSENT_STATUS.REQUESTED: return 'Solicitado';
    default: return 'Não solicitado';
  }
}
